var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorktimePana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.77,
    y: 381.1,
    width: 7.52,
    height: 56.3,
    transform: "translate(-284.72 533.79) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.06,405.8c.19,0,.35,1.58.35,3.53s-.16,3.52-.35,3.52-.36-1.58-.36-3.52S103.86,405.8,104.06,405.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.83,405.65c.2,0,.35,1.58.35,3.52s-.15,3.53-.35,3.53-.35-1.58-.35-3.53S102.63,405.65,102.83,405.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.33,405.8c.2,0,.36,1.58.36,3.53s-.16,3.52-.36,3.52-.35-1.58-.35-3.52S148.14,405.8,148.33,405.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.11,405.65c.19,0,.35,1.58.35,3.52s-.16,3.53-.35,3.53-.36-1.58-.36-3.53S146.91,405.65,147.11,405.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,409.48c0,.2-6.45.35-14.4.35s-14.4-.15-14.4-.35,6.45-.35,14.4-.35S139.75,409.28,139.75,409.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.77,
    y: 418.73,
    width: 15.04,
    height: 56.3,
    transform: "translate(-322.59 571.17) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.16,450.17s-.09.07-.3.17-.52.25-.94.43a16.18,16.18,0,0,1-3.82,1.09,9.92,9.92,0,0,1-6.19-.88,8.14,8.14,0,0,1-2.94-2.66,6.21,6.21,0,0,1-1-4.33,4.57,4.57,0,0,1,1-2.24,2.92,2.92,0,0,1,2.37-1.08,3.4,3.4,0,0,1,2.39,1.28,4.69,4.69,0,0,1,1.09,2.57,6.84,6.84,0,0,1-1.94,5.33,8.6,8.6,0,0,1-5.41,2.65,14.54,14.54,0,0,1-6.28-.78,11.62,11.62,0,0,1-5.49-3.69,6,6,0,0,1-1.28-3.25,4.23,4.23,0,0,1,1.2-3.38,2.78,2.78,0,0,1,1.76-.77,3.21,3.21,0,0,1,1.84.52,4.83,4.83,0,0,1,2.07,3,7.08,7.08,0,0,1-2.22,6.63,11.06,11.06,0,0,1-6.34,2.58,15.61,15.61,0,0,1-6.57-.65,9.08,9.08,0,0,1-5-3.89,6.64,6.64,0,0,1-.62-6,3.11,3.11,0,0,1,2.29-1.94,3.64,3.64,0,0,1,2.84.68,4.7,4.7,0,0,1,1.34,5.07,8.78,8.78,0,0,1-2.84,4,12.7,12.7,0,0,1-7.72,3,12.33,12.33,0,0,1-9.3-3.75,9.64,9.64,0,0,1-.68-.78,2,2,0,0,1-.2-.29,14.4,14.4,0,0,0,4.19,3.19,12.25,12.25,0,0,0,6,1.24,12.44,12.44,0,0,0,7.42-3,8.33,8.33,0,0,0,2.64-3.78,4.14,4.14,0,0,0-1.17-4.44,3.07,3.07,0,0,0-2.37-.56,2.49,2.49,0,0,0-1.84,1.6,6,6,0,0,0,.61,5.39,8.43,8.43,0,0,0,4.66,3.58,15,15,0,0,0,6.28.6,10.47,10.47,0,0,0,5.94-2.41,6.41,6.41,0,0,0,2-6,4.17,4.17,0,0,0-1.75-2.59,2.15,2.15,0,0,0-2.75.16,3.52,3.52,0,0,0-1,2.82,5.34,5.34,0,0,0,1.13,2.88,11,11,0,0,0,5.15,3.47,14,14,0,0,0,6,.77,8,8,0,0,0,5-2.42,6.24,6.24,0,0,0,1.81-4.85,3.58,3.58,0,0,0-2.92-3.37,2.43,2.43,0,0,0-1.95.88,4.08,4.08,0,0,0-.93,2,5.69,5.69,0,0,0,.91,4,7.81,7.81,0,0,0,2.75,2.57,9.74,9.74,0,0,0,6,.95,18,18,0,0,0,3.8-.95C152.72,450.33,153.15,450.14,153.16,450.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.76,
    y: 400.64,
    width: 26.1,
    height: 51.27,
    transform: "translate(-299.47 553.09) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.69,414.13c.19,0,.35,5.65.35,12.63s-.16,12.63-.35,12.63-.36-5.65-.36-12.63S109.49,414.13,109.69,414.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.58,413.8c.19,0,.35,5.59.35,12.47s-.16,12.47-.35,12.47-.36-5.58-.36-12.47S113.38,413.8,113.58,413.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.65,413c.19,0,.35,5.88.35,13.14s-.16,13.13-.35,13.13-.36-5.88-.36-13.13S146.45,413,146.65,413Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.08,413.32c.19,0,.35,5.72.35,12.79s-.16,12.79-.35,12.79-.36-5.72-.36-12.79S141.88,413.32,142.08,413.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.07,356.26c5.32-2.75,11.57-3.1,17.48-2.13,3.17.53,6.47,1.47,8.63,3.86s2.56,6.57.09,8.61c-1.48,1.22-3.53,1.41-5.45,1.38-4.62-.05-9.74-.86-13.43,1.92-2.11,1.58-3.51,4.22-6,5s-5.24-.69-6.54-2.91a10.16,10.16,0,0,1-.74-7.51A11.45,11.45,0,0,1,418.07,356.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.89,332.75c3.25,4.64,9.57,3.1,12.5.27s4.17-6.94,5.29-10.86c2.58-8.94,5.17-18.33,3.26-27.44a15.15,15.15,0,0,0-3.51-7.46,8,8,0,0,0-7.55-2.52c-3.18.85-5.16,4-6.59,6.93a65.52,65.52,0,0,0-6.47,28.08c0,4.52.52,9.26,3.07,13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,339.41c3.53-4.19,4.2-10.3,2.63-15.54s-5.12-9.72-9.21-13.36a49.57,49.57,0,0,0-16.49-9.73,17.67,17.67,0,0,0-7.41-1.26,7.77,7.77,0,0,0-6.22,3.77c-1.74,3.31-.07,7.32,1.73,10.6a126.43,126.43,0,0,0,10.82,16.48c3.25,4.19,7,8.32,11.91,10.21s10.09,1.66,12.71-1.77",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.67,402.77a10.44,10.44,0,0,0,.3-2.11c.15-1.53.33-3.46.56-5.75a84.17,84.17,0,0,1,1.29-8.45,64.85,64.85,0,0,1,3.07-10,37,37,0,0,1,5.09-9,19,19,0,0,1,6.43-5.35,18.47,18.47,0,0,1,5.42-1.69,9.57,9.57,0,0,0,2.1-.3,9.79,9.79,0,0,0-2.14,0,16.43,16.43,0,0,0-5.65,1.47,19,19,0,0,0-6.78,5.39,35.91,35.91,0,0,0-5.28,9.2,60.87,60.87,0,0,0-3,10.13,73.07,73.07,0,0,0-1.13,8.55c-.18,2.44-.25,4.42-.28,5.79A10.08,10.08,0,0,0,405.67,402.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.07,398.34a4.17,4.17,0,0,0,.06-1c0-.73,0-1.66,0-2.8,0-2.42,0-5.94.12-10.28.22-8.68,1-18,2.41-31.2,1.37-12.38,3.2-26.8,5.14-36.17.41-2.13.83-4.05,1.23-5.73s.69-3.13,1-4.3.48-2,.65-2.72a5.62,5.62,0,0,0,.18-1,3.79,3.79,0,0,0-.34.92c-.22.7-.49,1.59-.82,2.68s-.73,2.6-1.15,4.28-.9,3.59-1.35,5.72a317,317,0,0,0-5.41,33.56c-1.44,13.2-2.09,25.22-2.15,33.92-.05,4.35,0,7.87.15,10.3.07,1.14.13,2.07.17,2.8A4.14,4.14,0,0,0,406.07,398.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.13,375.16a18.64,18.64,0,0,0,0-2.92c-.11-1.88-.37-4.6-.9-7.92a104.22,104.22,0,0,0-2.57-11.54,95.33,95.33,0,0,0-4.83-13.66,72.68,72.68,0,0,0-14.17-22.07,37.91,37.91,0,0,0-3.34-3.1c-.51-.43-1-.86-1.42-1.2l-1.29-.89a17.72,17.72,0,0,0-2.47-1.58c-.14.19,3.49,2.32,8.07,7.2a76.6,76.6,0,0,1,13.82,22A107.15,107.15,0,0,1,401.86,353c1.27,4.24,2.11,8.14,2.75,11.42s.95,6,1.16,7.85A18.08,18.08,0,0,0,406.13,375.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.17 412.53 384.5 444.35 425.37 444.35 427.7 412.53 382.17 412.53",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.22,
    y: 399.99,
    width: 54.35,
    height: 12.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.22 443.13 378.22 446.61 380.78 446.61 431.68 446.61 431.68 443.13 378.22 443.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.28 452.34 380.78 446.23 429.73 446.23 426.81 452.34 383.28 452.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.94,422.93a1.31,1.31,0,0,1-.19.29c-.17.22-.37.48-.61.81l-2.39,3.05-.1.14-.1-.15c-1.5-2.07-3.5-4.83-5.85-8.09H418l-5.76,8.16-.18.25-.2-.24L405.06,419h.39l-.37.47L399,427.15l-.21.26-.18-.27c-2.08-2.93-4-5.68-5.77-8.15h.34l-7.1,8.09-.12.14-.1-.16-2.22-3.73c-.24-.41-.42-.74-.57-1a1.64,1.64,0,0,1-.18-.35,1.62,1.62,0,0,1,.24.31l.63,1,2.33,3.67-.22,0,7-8.19.17-.2.16.22,5.82,8.12h-.4l6.1-7.67.37-.48.2-.24.2.24,6.81,8.14-.38,0,5.82-8.12.17-.24.16.24,5.73,8.18h-.21c1.05-1.26,1.87-2.25,2.48-3l.66-.77C426.85,423,426.93,422.92,426.94,422.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.27,412.32c0,.14-10.25.25-22.88.25s-22.88-.11-22.88-.25,10.24-.25,22.88-.25S428.27,412.18,428.27,412.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.21,80.84s-.09,0-.24-.07l-.66-.26-2.52-1.05-9.25-4-30.4-13.24-1.06-.47h.22L121.51,74.54l-9,3.78-2.46,1a5.25,5.25,0,0,1-.87.31,5.88,5.88,0,0,1,.83-.41l2.42-1.1,9-3.95,29.72-12.89.11,0,.11,0,1.06.46,30.34,13.4,9.17,4.11,2.48,1.15.64.31A.85.85,0,0,1,195.21,80.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.34,
    y: 76.48,
    width: 195.29,
    height: 146.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.17,
    y: 83.28,
    width: 182.37,
    height: 133.42,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.45,141.57s.19,22.39,1.33,29.23l28.09-1.33s-2.46-22-1.51-27.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.29,144.73h.41a6.65,6.65,0,0,1,1.17.06,6.56,6.56,0,0,1,1.78.53,5.91,5.91,0,0,1,1.94,1.54,6.61,6.61,0,0,1,1.35,2.7,6.52,6.52,0,0,1-.29,3.47,10.38,10.38,0,0,1-.79,1.74,16,16,0,0,0-.9,1.75,15.32,15.32,0,0,0-1.14,4v.09h-.09l-2.77,0-2.91,0h-.11v-.1a8.31,8.31,0,0,0-1.35-3.84c-.34-.58-.71-1.11-1-1.66a17,17,0,0,1-1-1.61,5.45,5.45,0,0,1-.44-3.42,7.23,7.23,0,0,1,1.09-2.8,5.49,5.49,0,0,1,1.82-1.65,7.53,7.53,0,0,1,2.88-.85h.4s0,0-.1,0l-.3,0a7.7,7.7,0,0,0-1.13.22,6.92,6.92,0,0,0-1.69.69,5.28,5.28,0,0,0-1.77,1.63,7.26,7.26,0,0,0-1,2.75,5.24,5.24,0,0,0,.44,3.31,18.5,18.5,0,0,0,1,1.59c.35.53.72,1.08,1.06,1.66a8.36,8.36,0,0,1,1.39,3.94l-.11-.11,2.91,0,2.78,0-.11.1a15.45,15.45,0,0,1,1.16-4.05,18.42,18.42,0,0,1,.92-1.77,10.39,10.39,0,0,0,.78-1.7,6.38,6.38,0,0,0,.31-3.37,6.7,6.7,0,0,0-1.29-2.65,5.85,5.85,0,0,0-1.89-1.53,6.31,6.31,0,0,0-1.75-.55,8.85,8.85,0,0,0-1.15-.1h-.31C108.33,144.74,108.29,144.74,108.29,144.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.73,160.34a.66.66,0,0,1,0-.09l0-.26c0-.23-.09-.57-.15-1-.13-.88-.32-2.14-.44-3.71,0-.39-.06-.8-.07-1.23a12.08,12.08,0,0,1,0-1.35,3.69,3.69,0,0,1,.31-1.4,2.13,2.13,0,0,1,1.08-1.07,1.41,1.41,0,0,1,1.53.29,1,1,0,0,1,.32.77,1.36,1.36,0,0,1-.28.8,1.9,1.9,0,0,1-.68.55,3.5,3.5,0,0,1-.83.27,10.65,10.65,0,0,1-3.56.12,3.17,3.17,0,0,1-.85-.24,2.19,2.19,0,0,1-.7-.5,1.62,1.62,0,0,1-.41-.76,1.25,1.25,0,0,1,.1-.83,1.1,1.1,0,0,1,.59-.57,1,1,0,0,1,.79,0,1.47,1.47,0,0,1,.6.5,2.15,2.15,0,0,1,.3.7,9.11,9.11,0,0,1,.14,1.44l.14,2.57c.07,1.57.14,2.84.18,3.73,0,.43,0,.77,0,1v.35a.62.62,0,0,0,0-.09c0-.06,0-.15,0-.26s0-.58-.06-1c0-.89-.13-2.16-.22-3.73,0-.78-.09-1.64-.14-2.57a7.79,7.79,0,0,0-.15-1.42,1.88,1.88,0,0,0-.28-.67,1.56,1.56,0,0,0-.57-.48.93.93,0,0,0-.73,0,1.05,1.05,0,0,0-.55.53,1.22,1.22,0,0,0-.09.78,1.61,1.61,0,0,0,.39.71,2.56,2.56,0,0,0,1.5.72,10.4,10.4,0,0,0,1.77.08,10.2,10.2,0,0,0,1.76-.2,3.22,3.22,0,0,0,.81-.27,1.85,1.85,0,0,0,.65-.52,1.32,1.32,0,0,0,.27-.75,1,1,0,0,0-.3-.71,1.36,1.36,0,0,0-1.44-.28,2,2,0,0,0-1,1,3.74,3.74,0,0,0-.31,1.38c0,.46,0,.9,0,1.33s0,.84.07,1.24c.12,1.57.3,2.83.41,3.7.06.44.11.77.14,1l0,.26A.62.62,0,0,1,109.73,160.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,160.49a7.65,7.65,0,0,1,.08.93q0,1,.12,2.43l0-.06L108.1,166l-.1,0,2.19-.12-.09,0,1.08-1.32.55-.67,0,.09c0-1.29-.06-2.5-.08-3.6l.12.11-4.09,0H106a1.38,1.38,0,0,1,.39,0l1.15-.06,4.16-.16h.12v.12c0,1.11.07,2.32.11,3.6V164l0,0c-.18.22-.36.45-.55.67L110.29,166l0,0h-.06l-2.19.11H108l0,0-1.86-2.21,0,0v0c0-1,0-1.8,0-2.5A7.79,7.79,0,0,1,106,160.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.68,163.65s-.08,0-.21-.09a5.84,5.84,0,0,0-.57-.22,5.44,5.44,0,0,0-2-.3,5.55,5.55,0,0,0-2,.42l-.55.26-.2.1a.61.61,0,0,1,.18-.13,5.11,5.11,0,0,1,.55-.29,5.25,5.25,0,0,1,2-.45,5.09,5.09,0,0,1,2,.33,4,4,0,0,1,.56.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.67,162.78l-.2-.09-.57-.23a5.71,5.71,0,0,0-2-.3,6,6,0,0,0-2,.42c-.24.1-.42.19-.55.26l-.2.1.18-.13a3.9,3.9,0,0,1,.55-.28,5.24,5.24,0,0,1,2-.46,5.48,5.48,0,0,1,2,.33c.24.1.43.19.56.26S111.68,162.77,111.67,162.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.62,161.94l-.2-.08c-.14-.06-.33-.15-.57-.23a5.73,5.73,0,0,0-2-.3,5.49,5.49,0,0,0-2,.42c-.24.1-.42.19-.55.26l-.2.1.18-.13a4.29,4.29,0,0,1,.55-.29,5.46,5.46,0,0,1,2-.45,5.52,5.52,0,0,1,2,.33,4.44,4.44,0,0,1,.56.26A.65.65,0,0,1,111.62,161.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.17,105s.19,22.4,1.33,29.23l28.09-1.33s-2.47-22-1.52-27.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.84,114.36a81.58,81.58,0,0,1-9.41.84,77.21,77.21,0,0,1-9.45.29,84.34,84.34,0,0,1,9.41-.84A82.34,82.34,0,0,1,86.84,114.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.84,119.1a79.57,79.57,0,0,1-9.41.85,82.16,82.16,0,0,1-9.44.29,81.28,81.28,0,0,1,9.41-.84A81,81,0,0,1,86.84,119.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.07,123.76a26.76,26.76,0,0,1-5.36.6,26.57,26.57,0,0,1-5.38,0,26.72,26.72,0,0,1,5.35-.6A26.65,26.65,0,0,1,82.07,123.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.84,170.85s.19,22.39,1.33,29.23l28.09-1.33s-2.47-22-1.52-27.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.51,180.25a80.16,80.16,0,0,1-9.41.85,82.2,82.2,0,0,1-9.44.29,80.94,80.94,0,0,1,9.4-.84A81.14,81.14,0,0,1,85.51,180.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.51,185a81,81,0,0,1-9.41.84,82.16,82.16,0,0,1-9.44.29,81.28,81.28,0,0,1,9.41-.84A82.18,82.18,0,0,1,85.51,185Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.74,189.66a26.32,26.32,0,0,1-5.35.59,26.65,26.65,0,0,1-5.39.05,26.72,26.72,0,0,1,5.35-.6A26.18,26.18,0,0,1,80.74,189.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.61 110.89 141.39 175.49 222.03 176.46 218.41 111.74 138.61 110.89",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.67,
    y: 110.43,
    width: 80.11,
    height: 60.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.78,170.92s0-.39,0-1.13,0-1.82,0-3.22c0-2.84,0-7-.06-12.24,0-10.55-.07-25.64-.12-43.9l.23.22-80.1,0h0l.28-.27c0,21.75,0,42.35,0,60.49l-.25-.25,57.78.12,16.44.07,4.37,0h1.13l.39,0h-1.47L212,171l-16.37.07-58,.12h-.25v-.24c0-18.14,0-38.74,0-60.49v-.28h.28l80.1,0H218v.23c0,18.31-.09,33.46-.12,44,0,5.25,0,9.36-.06,12.19q0,2.07,0,3.18C217.8,170.56,217.78,170.92,217.78,170.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.34,
    y: 123.24,
    width: 32.47,
    height: 40.87,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.81,164.11a.67.67,0,0,1,0-.21l0-.58c0-.54,0-1.28,0-2.23,0-2,0-4.81-.06-8.39,0-7.19-.08-17.37-.13-29.46l.25.25-32.47,0c-.07,0,.52-.52.27-.27h0v11.11c0,3.63,0,7.17,0,10.6,0,6.87,0,13.3,0,19.14l-.22-.23,23.51.12,6.59.06,1.75,0,.62,0a3.92,3.92,0,0,1-.57,0l-1.7,0-6.55.06-23.65.12h-.23v-.23c0-5.84,0-12.27,0-19.14,0-3.43,0-7,0-10.6V123.26h0c-.25.24.33-.35.28-.28l32.47,0h.25v.25c-.05,12.15-.1,22.39-.13,29.62l-.06,8.33q0,1.4,0,2.19c0,.22,0,.4,0,.55A1.23,1.23,0,0,1,179.81,164.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.58,
    y: 113.89,
    width: 62.23,
    height: 5.89,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.81,119.78s0-.15,0-.4,0-.67,0-1.15c0-1,0-2.47-.07-4.34l.11.11c-10.49.1-34.41.17-62.23.17h0c.55-.56.15-.16.28-.28h0v5.87l-.27-.28,44.11.12,13.24.08,3.6,0,.95,0a2.22,2.22,0,0,1,.33,0l-.29,0-.91,0-3.54,0-13.18.09-44.31.11h-.27v-.27c0-.94,0-1.91,0-2.89v-3h0l.28-.28h0c27.82,0,51.74.07,62.23.17h.12v.11c0,1.89,0,3.37-.06,4.41,0,.47,0,.83,0,1.11A1.59,1.59,0,0,1,210.81,119.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.78,
    y: 123.24,
    width: 27.03,
    height: 24.63,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.81,147.87s0-.17,0-.47l0-1.34c0-1.2,0-2.89-.06-5,0-4.34-.07-10.45-.12-17.8l.23.24-27,0,.27-.27h0v6.61c0,2.16,0,4.28,0,6.35,0,4.13,0,8,0,11.66l-.25-.24,19.5.12,5.53.07,1.48,0a3.09,3.09,0,0,1,.52,0,2.56,2.56,0,0,1-.47,0l-1.43,0-5.47.06-19.66.12h-.24v-.25c0-3.61,0-7.53,0-11.66,0-2.07,0-4.19,0-6.35v-6.61h0c-.25.24.33-.34.28-.28l27,0h.24v.23c-.05,7.41-.09,13.58-.12,18,0,2.1-.05,3.77-.06,5q0,.79,0,1.29A2,2,0,0,1,210.81,147.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.78,
    y: 151.73,
    width: 27.03,
    height: 12.38,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.81,164.11s0-.32,0-.9l-.05-2.48c0-2.19-.06-5.24-.11-9l.2.2-27,.08c-.25.25.33-.34.27-.27h0v6.37c0,2.07,0,4.08,0,6l-.27-.26,19.33.12,5.64.08,1.52,0,.54,0a2.62,2.62,0,0,1-.48,0l-1.47,0-5.57.08-19.51.12h-.26v-.26c0-1.92,0-3.93,0-6v-6.37h0c-.06,0,.52-.53.28-.28l27,.07H211v.2c0,3.81-.08,6.91-.1,9.12,0,1,0,1.83,0,2.44A4.89,4.89,0,0,1,210.81,164.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,123.31c-10.06,13.89-21.62,26.91-31.67,40.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.34,164.11s.07-.17.26-.46l.85-1.24c.74-1.08,1.85-2.61,3.25-4.48,2.79-3.76,6.78-8.84,11.26-14.39s8.51-10.59,11.37-14.28l3.39-4.37.93-1.19c.22-.26.34-.4.36-.39a2.38,2.38,0,0,1-.27.46l-.85,1.24c-.74,1.08-1.85,2.61-3.25,4.49-2.79,3.75-6.78,8.83-11.26,14.38s-8.5,10.59-11.37,14.28l-3.39,4.38-.93,1.18A2.25,2.25,0,0,1,147.34,164.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.34,
    y1: 123.24,
    x2: 179.81,
    y2: 164.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.81,164.11c-.12.09-7.49-9-16.45-20.26s-16.14-20.51-16-20.61,7.48,9,16.45,20.27S179.93,164,179.81,164.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.39,123.33a5.08,5.08,0,1,1-5.08-5.08A5.09,5.09,0,0,1,141.39,123.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.48,111a5.08,5.08,0,1,1-5.08-5.08A5.09,5.09,0,0,1,224.48,111Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.66,
    y: 146.38,
    width: 58.54,
    height: 84.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.73,
    y: 146.38,
    width: 58.54,
    height: 84.86,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 155.57,
    width: 44,
    height: 66.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,222.05s0-.12,0-.33,0-.53,0-.94c0-.84,0-2.06,0-3.65,0-3.18,0-7.83,0-13.69,0-11.72,0-28.32-.07-47.87l.15.15H369l.16-.16c0,25.08,0,48.2,0,66.48l-.13-.13,32,.07,8.85,0h2.32l.81,0h-.78l-2.3,0-8.82,0-32.1.06h-.13v-.12c0-18.28,0-41.4,0-66.48v-.16H369l44,0h.14v.14c0,19.59-.05,36.22-.07,48,0,5.85,0,10.48,0,13.66,0,1.57,0,2.78,0,3.61,0,.41,0,.71,0,.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.43,146.38a9.18,9.18,0,0,1-1,1.52c-.68.91-1.65,2.14-2.75,3.48s-2.13,2.52-2.89,3.37a9.84,9.84,0,0,1-1.29,1.31,11.46,11.46,0,0,1,1.12-1.46l2.82-3.42,2.81-3.42A12.41,12.41,0,0,1,420.43,146.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.22,221.83a54.16,54.16,0,0,0,7.67,9.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.89,231.43a8.18,8.18,0,0,1-1.33-1.22,42,42,0,0,1-2.9-3.26,43.25,43.25,0,0,1-2.55-3.54,8.52,8.52,0,0,1-.89-1.58,13,13,0,0,1,1.08,1.45c.64.91,1.55,2.14,2.61,3.47s2.07,2.48,2.81,3.31A11.55,11.55,0,0,1,420.89,231.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.72,231.17l7.67-9.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.39,221.71c.06,0-1.6,2.22-3.71,4.83a57.8,57.8,0,0,1-4,4.63,115.9,115.9,0,0,1,7.67-9.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.73,146.38a57.7,57.7,0,0,1,3.72,4.45,52.46,52.46,0,0,1,3.47,4.65A55.13,55.13,0,0,1,365.2,151,50.16,50.16,0,0,1,361.73,146.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.56,
    y: 169.07,
    width: 14.73,
    height: 41.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.44,
    y: 56.26,
    width: 8.38,
    height: 41.7,
    transform: "translate(-0.41 2.17) rotate(-0.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.79,
    y: 56.4,
    width: 21.7,
    height: 23.02,
    transform: "translate(-0.36 1.82) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.38,
    y: 56.29,
    width: 21.7,
    height: 23.02,
    transform: "translate(-0.36 1.94) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.76,62.82c14.42.12,28.88,0,43.3-.2a.23.23,0,0,0,0-.46q-21.65-.12-43.3.26a.2.2,0,0,0,0,.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.24,
    y: 79.09,
    width: 39.43,
    height: 18.76,
    transform: "translate(-0.47 1.8) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.49,
    y: 78.88,
    width: 39.43,
    height: 18.76,
    transform: "translate(-0.47 2.01) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.22,84.41c26.2.3,52.48,0,78.67-.39a.23.23,0,0,0,0-.46c-26.2-.14-52.48-.12-78.67.45a.2.2,0,0,0,0,.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.48,
    y: 97.95,
    width: 152.76,
    height: 6.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.49,
    y: 101.18,
    width: 6.2,
    height: 22.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.06,
    y: 101.18,
    width: 6.2,
    height: 22.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.66,
    y: 40.71,
    width: 8.38,
    height: 57.35,
    transform: "translate(-0.37 2.22) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.08,
    y: 51.4,
    width: 13.02,
    height: 46.48,
    transform: "translate(-0.39 2.28) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.89,60.31a92.25,92.25,0,0,1-13,0,96.43,96.43,0,0,1,13,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.89,58.36a92.25,92.25,0,0,1-13,0,96.43,96.43,0,0,1,13,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.89,90.84a92.25,92.25,0,0,1-13,0,96.43,96.43,0,0,1,13,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.89,88.89a92.25,92.25,0,0,1-13,0,96.43,96.43,0,0,1,13,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.59,84.63c-.13,0-.23-4.69-.23-10.47s.1-10.47.23-10.47.22,4.69.22,10.47S424.71,84.63,424.59,84.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.03,
    y: 62.77,
    width: 14.17,
    height: 35.08,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.52,88.76a3,3,0,0,1-3.17-3.16,2.74,2.74,0,0,1,1.15-2.37l.32.45a2.27,2.27,0,0,0-.93,1.92,2.63,2.63,0,0,0,5.26,0,2.25,2.25,0,0,0-.94-1.92l.33-.45a2.78,2.78,0,0,1,1.14,2.37A3,3,0,0,1,438.52,88.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.88,82.36l-.47-.27a3.68,3.68,0,0,0,.75-2.25c0-1.31-.47-1.84-1.17-1.84-1.82,0-.48,4.14-2.93,4.14-.94,0-1.71-.79-1.71-2.37a3.84,3.84,0,0,1,.61-2.14l.48.28a3.2,3.2,0,0,0-.56,1.87c0,1.22.5,1.76,1.17,1.76,1.87,0,.55-4.14,2.93-4.14,1,0,1.7.88,1.7,2.47A3.87,3.87,0,0,1,440.88,82.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.88,76.65l-.47-.27a3.68,3.68,0,0,0,.75-2.25c0-1.31-.47-1.84-1.17-1.84-1.82,0-.48,4.13-2.93,4.13-.94,0-1.71-.78-1.71-2.36a3.84,3.84,0,0,1,.61-2.14l.48.27a3.25,3.25,0,0,0-.56,1.88c0,1.22.5,1.76,1.17,1.76,1.87,0,.55-4.14,2.93-4.14,1,0,1.7.87,1.7,2.46A3.88,3.88,0,0,1,440.88,76.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.57,
    cy: 50.48,
    r: 2.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.82,
    y: 57.1,
    width: 1.49,
    height: 34.12,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.81,454c0,.14-96.59.26-215.71.26S39.37,454.16,39.37,454s96.57-.26,215.73-.26S470.81,453.88,470.81,454Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hourglass--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.18,110.24c-16.05,25.24-15,60.24,2.54,84.47,11.69,16.16,29.22,27,43.14,41.26s24.5,35.31,17.15,53.85c-7.48,18.87-29.39,26.54-45.79,38.5a86.54,86.54,0,0,0-20.88,118.22H322.76S352.7,389.49,314.21,346s-59.16-44.19-57.74-72.71,21.38-37.77,32.79-48.47,67-35.63,34.21-114.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.18,110.24l2.93,0,8.64,0,33.26,0,122.46-.09h.13l0,.12A157,157,0,0,1,330,128.62a106.73,106.73,0,0,1,3.62,20,79.23,79.23,0,0,1-1.08,21.17,68.07,68.07,0,0,1-7.7,20.58,73.76,73.76,0,0,1-6.42,9.31,85.07,85.07,0,0,1-7.85,8.4,113.75,113.75,0,0,1-8.91,7.55c-3.1,2.4-6.34,4.66-9.5,7.06-1.58,1.19-3,2.53-4.54,3.87s-3.07,2.59-4.65,3.85c-3.15,2.52-6.33,5-9.33,7.79a49.9,49.9,0,0,0-14,20.08A49,49,0,0,0,257,270.6c-.09,1-.23,2.1-.27,3.16s-.08,2.12,0,3.18a35.49,35.49,0,0,0,.64,6.34A28.93,28.93,0,0,0,262.43,295a64.34,64.34,0,0,0,8.83,9.57c6.47,5.91,13.34,11.56,19.91,17.66s13,12.46,19.2,19.19a113.78,113.78,0,0,1,8.86,10.54,73.42,73.42,0,0,1,7.15,11.91,78.34,78.34,0,0,1,7.34,27,99.09,99.09,0,0,1-1.66,28.4,116.68,116.68,0,0,1-3.66,13.94A102.51,102.51,0,0,1,323,446.66l-.07.14H152.2l-.07-.11a87.85,87.85,0,0,1-14.27-40.23,84.82,84.82,0,0,1,5.9-40.6,88.4,88.4,0,0,1,22.52-32.18,102.56,102.56,0,0,1,15.38-11.22c5.32-3.3,10.69-6.36,15.76-9.7a72.44,72.44,0,0,0,13.88-11.28,38.06,38.06,0,0,0,8.58-14.88,37.1,37.1,0,0,0,.68-16.61,54.37,54.37,0,0,0-5.27-15.27,74.52,74.52,0,0,0-8.58-13,102.7,102.7,0,0,0-10.38-10.83c-7.21-6.64-14.6-12.45-21.24-18.42-3.33-3-6.48-6-9.39-9.07a85.75,85.75,0,0,1-7.78-9.59,73.48,73.48,0,0,1-9.75-20.21,75.81,75.81,0,0,1-3.32-19.15c-.14-1.48-.08-2.94-.08-4.37s0-2.82.13-4.17.2-2.67.3-4,.37-2.52.54-3.73A71.18,71.18,0,0,1,152.42,117a26.78,26.78,0,0,1,1.54-3l1.23-2.09c.65-1.11,1-1.67,1-1.67l-1,1.7L154,114a30.15,30.15,0,0,0-1.52,3,71.53,71.53,0,0,0-6.6,21.21c-.17,1.2-.37,2.44-.52,3.71s-.2,2.6-.3,3.95-.1,2.74-.11,4.16-.05,2.88.09,4.36a75.19,75.19,0,0,0,3.35,19.08,73,73,0,0,0,9.74,20.13,84.1,84.1,0,0,0,7.77,9.54c2.9,3.08,6.05,6.08,9.38,9,6.64,6,14,11.75,21.26,18.4A103.36,103.36,0,0,1,207,241.45a75.25,75.25,0,0,1,8.63,13.09,54.58,54.58,0,0,1,5.32,15.37,37.47,37.47,0,0,1-.68,16.79,38.3,38.3,0,0,1-8.66,15.05,73.38,73.38,0,0,1-13.94,11.36c-5.09,3.35-10.46,6.41-15.77,9.71A102.78,102.78,0,0,0,166.58,334a88.06,88.06,0,0,0-22.39,32,84.33,84.33,0,0,0-5.85,40.39,87.46,87.46,0,0,0,14.2,40l-.2-.11H322.76l-.23.14A101,101,0,0,0,327.91,433a116.15,116.15,0,0,0,3.64-13.88,98.48,98.48,0,0,0,1.65-28.26,77.52,77.52,0,0,0-7.29-26.85,73.52,73.52,0,0,0-7.09-11.83,116.64,116.64,0,0,0-8.82-10.5q-9.25-10.07-19.17-19.16c-6.56-6.09-13.41-11.73-19.9-17.67a65.52,65.52,0,0,1-8.91-9.64,29.51,29.51,0,0,1-5.19-11.87,37.68,37.68,0,0,1-.65-6.43c-.05-1.07,0-2.14,0-3.21s.18-2.13.26-3.19a49.68,49.68,0,0,1,2.7-12.39,50.25,50.25,0,0,1,14.13-20.25c3-2.78,6.21-5.3,9.36-7.81,1.58-1.26,3.13-2.53,4.64-3.83s3-2.7,4.56-3.9c3.18-2.4,6.41-4.66,9.5-7.05a115.17,115.17,0,0,0,8.89-7.51,86.48,86.48,0,0,0,7.81-8.35,75.9,75.9,0,0,0,6.39-9.26,67.61,67.61,0,0,0,7.66-20.44,78.74,78.74,0,0,0,1.09-21,106.89,106.89,0,0,0-3.59-20,158.72,158.72,0,0,0-6.32-18.41l.17.11-122.39-.09-33.28,0-8.66,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.67,156.53c25.1,4.13-14.47,48.59-36.88,66.13-13,10.15-26.9,21.17-33.06,36.45-7,17.34-1.81,36.82-5.19,54.26a2.42,2.42,0,0,1-4.8-.51c.16-11.45-.14-22.89-2-34.16-2.69-16-8.83-31.79-20-43.5-9.15-9.57-21.14-15.92-30.89-24.86-14.24-13.05-28.87-29.88-30.3-49.14,0,0,27.34-22,42.52-19.25,17.74,3.25,35.2,30.62,62.68,27.49C277.87,167.25,287.56,151.75,316.67,156.53Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9,394.48c-.63-6.28-2.31-13.38-7.88-16.34-3.37-1.8-7.48-1.6-11.18-.63s-7.17,2.66-10.83,3.75a35.47,35.47,0,0,1-22.17-.71c-6.81-2.5-12.65-7-19-10.58s-13.72-6.2-20.76-4.45c-12.14,3-18.46,17.64-30.46,21.17-5.34,1.56-11.07.68-16.49-.54s-10.87-2.81-16.42-2.6c-4.36.16-8.89,1.67-11.94,4.65l0,0-.08.09a11.82,11.82,0,0,0-1.38,1.62c-3.72,5-4.32,11.63-3.17,17.69,1.28,6.79,4.45,13.06,7.85,19.07,4,7.08,8.56,14.12,15.18,18.84,8.18,5.83,18.45,1.81,28.46,2.6,23.33,1.84,48.43,3.09,71.77,1.29,12.33-1,23.88.38,33.66-7.19,6.88-5.32,11.36-13.34,13.52-21.76S319.77,403.13,318.9,394.48Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.24
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.86,382.46c-1.31,2-1.88,4.72-.61,6.76s3,3.91,3.54,6.26c.87,3.68-1.35,7.28-3,10.69a34.05,34.05,0,0,0-3.31,19.73,26.84,26.84,0,0,0,9.79,17.23c2.37,1.83,5.45,3.25,8.31,2.35,2.69-.84,4.42-3.57,5-6.34s.09-5.62-.26-8.41a130.64,130.64,0,0,1,1-39.08c.38-2.15.74-4.61-.62-6.32a7.32,7.32,0,0,0-3.59-2c-5.2-1.73-10.81.19-16.2-.83"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M139.83,454.28s-.47-7.82,9.73-12.18H328.81s9.35,4.74,10.5,12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,111.19l-.29.13-168.55-1.08s-.6-.38-1.49-1.09a6.39,6.39,0,0,1,4-11.42l163.6,1.32C329,99.11,331.12,108.31,325,111.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.24
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298,175.49c.34.65-.93,2-3.34,4.2s-6,5.09-10.46,8.72a137.3,137.3,0,0,1-17,12,68.21,68.21,0,0,1-11.64,5.35,55.12,55.12,0,0,1-6.69,1.85,45.64,45.64,0,0,1-7.23.94,38.6,38.6,0,0,1-14.53-2,52.36,52.36,0,0,1-11.68-6c-3.36-2.22-6.25-4.42-9-6.53s-5.2-4.14-7.42-6.06c-8.85-7.67-13.51-13.31-12.61-14.4s7.2,2.46,17,8.46l8,4.9c2.87,1.74,5.94,3.67,9.08,5.45a50.84,50.84,0,0,0,9.85,4.45,31.63,31.63,0,0,0,10.84,1.28c7.68-.4,15.13-3.1,21.58-6.22s12.29-6.76,17.35-9.6a87.41,87.41,0,0,1,12.52-6.1C295.79,175.07,297.71,174.86,298,175.49Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M236.86,334.26a2.9,2.9,0,1,1-.14.06",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.58,203.38a4.33,4.33,0,0,1-.6-.6L174.35,201c-.69-.79-1.6-1.71-2.53-2.88l-3.18-4c-1.09-1.54-2.32-3.2-3.56-5l-1.83-2.91c-.31-.5-.64-1-.94-1.53l-.88-1.62a67.6,67.6,0,0,1-6.21-14.95,63,63,0,0,1-2.36-16c0-1.25.07-2.46.09-3.65,0-.59,0-1.17.08-1.74s.12-1.13.18-1.68c.13-1.1.21-2.17.36-3.19s.36-2,.53-2.91c.28-1.87.78-3.5,1.13-5,.19-.72.34-1.4.53-2l.55-1.67.77-2.29a4.26,4.26,0,0,1,.3-.79,4.55,4.55,0,0,1-.2.82c-.17.58-.39,1.35-.68,2.32L156,132c-.17.61-.31,1.29-.49,2-.32,1.45-.79,3.09-1,5-.16.92-.32,1.89-.49,2.9s-.21,2.07-.33,3.17c0,.55-.11,1.1-.17,1.67s0,1.15-.06,1.73c0,1.18-.08,2.38-.07,3.62A63.34,63.34,0,0,0,155.72,168a68.82,68.82,0,0,0,6.13,14.86c.29.54.58,1.08.86,1.62s.63,1,.93,1.52l1.8,2.91c1.22,1.84,2.43,3.5,3.49,5l3.12,4c.9,1.19,1.79,2.12,2.45,2.94l1.56,1.85A6.8,6.8,0,0,1,176.58,203.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.09,351.94a2,2,0,0,1,.18-.33l.6-.94c.27-.42.6-.92,1-1.52l.63-1c.25-.33.54-.66.83-1l2-2.4c.77-.83,1.65-1.69,2.58-2.63a67.67,67.67,0,0,1,6.86-5.78c5.31-4,12.16-8,19.58-12.69a112,112,0,0,0,11.23-7.91,52.39,52.39,0,0,0,10.07-10.64,50.37,50.37,0,0,0,8.15-26.83,63.47,63.47,0,0,0-3.84-22.8,85.1,85.1,0,0,0-6.62-14.2c-.93-1.61-1.69-2.83-2.21-3.66l-.59-.94c-.13-.21-.19-.33-.19-.33a1.48,1.48,0,0,1,.23.3l.64.92c.55.8,1.34,2,2.29,3.61a81.16,81.16,0,0,1,6.8,14.18,63.41,63.41,0,0,1,4,22.93,54,54,0,0,1-.55,6.74,49.25,49.25,0,0,1-1.47,6.91A46.82,46.82,0,0,1,223,305.4a52.73,52.73,0,0,1-10.18,10.75,113.44,113.44,0,0,1-11.29,7.92c-7.45,4.65-14.31,8.61-19.62,12.58a70.42,70.42,0,0,0-6.88,5.69c-.93.93-1.82,1.77-2.6,2.59l-2,2.35c-.3.36-.59.69-.84,1l-.65.95-1,1.49-.64.91A2.33,2.33,0,0,1,167.09,351.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.79,369.61a3.16,3.16,0,0,1-.22.47l-.72,1.27c-.32.54-.7,1.22-1.09,2s-.89,1.7-1.31,2.75c-.22.52-.46,1.06-.7,1.62s-.44,1.18-.68,1.8c-.48,1.24-.86,2.6-1.3,4A54.34,54.34,0,0,0,150,402.8c.17,1.48.29,2.9.55,4.2.11.65.2,1.29.33,1.89s.27,1.18.4,1.73c.22,1.11.55,2.08.79,2.94s.48,1.6.7,2.2l.47,1.38a1.71,1.71,0,0,1,.13.49,1.9,1.9,0,0,1-.23-.45c-.15-.37-.33-.81-.56-1.35a21.57,21.57,0,0,1-.79-2.18c-.27-.86-.62-1.83-.87-2.94-.14-.55-.28-1.13-.43-1.73s-.24-1.25-.37-1.9c-.28-1.32-.42-2.74-.6-4.23a52.34,52.34,0,0,1,1.78-19.4c.45-1.44.85-2.81,1.36-4.05.25-.62.45-1.23.71-1.8l.74-1.63c.44-1,1-1.93,1.39-2.73a20.73,20.73,0,0,1,1.17-2l.8-1.23C157.67,369.74,157.77,369.6,157.79,369.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.42,393.65l-.2.14-.62.39-2.43,1.46-1.76,1c-.66.37-1.39.71-2.17,1.1-1.58.76-3.32,1.73-5.38,2.51l-3.2,1.31c-1.11.44-2.32.79-3.54,1.21-2.43.89-5.13,1.53-7.94,2.26a93.09,93.09,0,0,1-37.61,1c-2.86-.58-5.58-1.08-8.06-1.84-1.24-.36-2.46-.64-3.6-1L201.65,402c-2.09-.67-3.89-1.54-5.5-2.22-.8-.35-1.55-.66-2.22-1l-1.82-.95-2.5-1.33-.64-.36-.21-.13s.09,0,.24.09l.66.31,2.54,1.24,1.83.9c.68.32,1.44.61,2.24.95,1.61.64,3.41,1.49,5.51,2.13L205,402.8c1.14.38,2.36.65,3.6,1,2.47.74,5.18,1.21,8,1.78a95.06,95.06,0,0,0,37.42-1c2.8-.72,5.49-1.33,7.92-2.2,1.22-.41,2.42-.74,3.53-1.18l3.2-1.27c2.06-.76,3.81-1.7,5.39-2.43.78-.38,1.52-.71,2.18-1l1.78-1,2.47-1.38.65-.34C281.34,393.67,281.42,393.64,281.42,393.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.85,182a1.06,1.06,0,0,1-.21.19l-.66.54c-.61.49-1.46,1.18-2.55,2-2.22,1.76-5.44,4.31-9.51,7.35A137.5,137.5,0,0,1,264.05,202a67,67,0,0,1-9.58,4.41,43.67,43.67,0,0,1-11.06,2.46,42,42,0,0,1-21.24-4.42,72.06,72.06,0,0,1-8.21-4.88c-2.44-1.72-4.67-3.39-6.64-5-4-3.18-7.06-5.87-9.22-7.71l-2.47-2.14-.63-.56-.21-.21s.09,0,.24.16l.67.53,2.53,2.06c2.2,1.8,5.34,4.44,9.32,7.58,2,1.57,4.21,3.22,6.66,4.92a73,73,0,0,0,8.17,4.8,41.85,41.85,0,0,0,21,4.33,43.36,43.36,0,0,0,10.93-2.42,67.07,67.07,0,0,0,9.52-4.35,143.81,143.81,0,0,0,14.89-9.71c4.08-3,7.33-5.5,9.6-7.21l2.61-2,.69-.5A.9.9,0,0,1,291.85,182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.24
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.66,402.05c4.74-3.66,11.4-2.78,17.26-1.54s11.76,3.23,17.69,2.4c4.47-.63,8.57-2.82,13-3.78s9.76-.25,12.21,3.54a95,95,0,0,1-60.13-.62"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367,374.91,345.5,350.8l-.22,29.31,6.48,18.8-64.42,11.17-2.73-50.83-4.64-39a10.6,10.6,0,0,1,6.64-11.11l17.73-7,25,4.58,10.05,3.82a27.59,27.59,0,0,1,10.94,7.61l30.24,34.58",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,345a31.46,31.46,0,0,0,3.63-.26,14.73,14.73,0,0,0,12.11-11.16,33.43,33.43,0,0,0,.55-3.61,3.28,3.28,0,0,1,.09,1,12.19,12.19,0,0,1-.28,2.7,14.44,14.44,0,0,1-12.41,11.45,12.76,12.76,0,0,1-2.71.06A3.11,3.11,0,0,1,344,345Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.87,378.86c.15,0,.19-10.16.09-22.68s-.31-22.67-.46-22.67-.19,10.15-.09,22.68S345.72,378.86,345.87,378.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.51,386.31l-38.92-15.67a8.9,8.9,0,0,1-5.55-7.57l-2.85-37.32s.34-15.88-9.58-16.65L281,311.32c-7.29,3.87-9.09,14.49-8.1,22.68,1.41,11.64,2,28.12,3.57,38.22,1.3,8.27,6,15.54,14.12,17.67l47.94,10.38Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.75,331.44a4.84,4.84,0,0,1,.12.85c.06.61.15,1.43.25,2.46.2,2.19.48,5.27.82,9.05s.72,8.39,1.16,13.43c.1,1.27.21,2.56.32,3.88a30.15,30.15,0,0,0,.5,4,6.61,6.61,0,0,0,1.94,3.49,13,13,0,0,0,3.59,2.24c10.73,4.64,20.62,8.48,27.8,11.17l8.53,3.14,2.32.85a5.59,5.59,0,0,1,.79.33,4.8,4.8,0,0,1-.83-.23l-2.35-.76c-2-.68-5-1.69-8.58-3-7.23-2.6-17.13-6.38-27.9-11A13.61,13.61,0,0,1,301.5,369a7.13,7.13,0,0,1-2.08-3.76,29.16,29.16,0,0,1-.49-4.06c-.11-1.33-.21-2.62-.31-3.89-.39-5-.75-9.6-1-13.44s-.5-6.87-.66-9.06c-.07-1-.12-1.86-.15-2.47A5.09,5.09,0,0,1,296.75,331.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.45,351.73a2.5,2.5,0,0,1,.07.5l.13,1.44c.12,1.33.27,3.12.46,5.3s.49,4.89.88,7.83a75.74,75.74,0,0,0,1.75,9.45,14.23,14.23,0,0,0,1.9,4.51,27.52,27.52,0,0,0,2.91,3.57,25,25,0,0,0,6.23,4.67,23.5,23.5,0,0,0,6.84,2.24,2,2,0,0,1-.51,0,11.22,11.22,0,0,1-1.44-.19,18.91,18.91,0,0,1-5.06-1.71,24.39,24.39,0,0,1-6.4-4.66,26.52,26.52,0,0,1-3-3.63,14.52,14.52,0,0,1-2-4.65,70.74,70.74,0,0,1-1.73-9.53c-.36-3-.6-5.62-.76-7.86s-.25-4.06-.3-5.32c0-.58,0-1.06,0-1.45A1.61,1.61,0,0,1,274.45,351.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.09,377.84a5.76,5.76,0,0,1,.71-2.07,13.42,13.42,0,0,1,7.9-6.75,5.65,5.65,0,0,1,2.16-.37,21.52,21.52,0,0,1-2,.72,15.3,15.3,0,0,0-4.41,2.63,15.49,15.49,0,0,0-3.29,3.94C291.46,377.09,291.17,377.87,291.09,377.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.75,349.46a.92.92,0,0,1,.24.11l.7.37a25.38,25.38,0,0,0,2.78,1.17,22,22,0,0,0,10.91.94,21.54,21.54,0,0,0,13.56-8.43,17.91,17.91,0,0,0,3.55-8.82,12,12,0,0,0-.52-5,10.2,10.2,0,0,0-2.8-4.29,8.59,8.59,0,0,0-4.57-2.22,5.45,5.45,0,0,0-4.58,1.29,3,3,0,0,0-.9,2.07,3.62,3.62,0,0,0,.76,2.14,5.84,5.84,0,0,0,4,2.07,16.3,16.3,0,0,0,14.53-5.73,16.32,16.32,0,0,0,2.94-5.51,17.41,17.41,0,0,0,.74-4.69,17.89,17.89,0,0,0-.22-3c-.06-.31-.11-.57-.14-.77a1.41,1.41,0,0,1,0-.27,12.65,12.65,0,0,1,.6,4,16.8,16.8,0,0,1-.66,4.77,16.46,16.46,0,0,1-17.83,11.63,6.29,6.29,0,0,1-4.28-2.24,4.09,4.09,0,0,1-.86-2.44,3.46,3.46,0,0,1,1-2.43,6,6,0,0,1,5-1.44,9,9,0,0,1,4.85,2.35,10.54,10.54,0,0,1,2.94,4.51,12.5,12.5,0,0,1,.54,5.2,18.31,18.31,0,0,1-3.67,9,21.49,21.49,0,0,1-24.93,7.4A15.48,15.48,0,0,1,298.75,349.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.25,339.51a3.19,3.19,0,0,1,.64-.8,14.38,14.38,0,0,1,2.1-1.83,17.66,17.66,0,0,1,8.61-3.05,16.64,16.64,0,0,1,5.08.21,15.46,15.46,0,0,1,3.91,1.38,18,18,0,0,1,2.38,1.44,3.36,3.36,0,0,1,.78.66c-.06.08-1.22-.8-3.32-1.77a16.3,16.3,0,0,0-8.77-1.4,18.46,18.46,0,0,0-8.46,2.83C274.27,338.47,273.32,339.58,273.25,339.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.48,312.82a15.39,15.39,0,0,0,3.15,2.29,11.22,11.22,0,0,0,4,1.18,10.66,10.66,0,0,0,5-.7,10.5,10.5,0,0,0,4-3,11.5,11.5,0,0,0,2-3.67,16,16,0,0,0,.61-3.85,3.5,3.5,0,0,1,.13,1.06,9.74,9.74,0,0,1-.39,2.9,11.18,11.18,0,0,1-2,3.86,10.22,10.22,0,0,1-9.5,3.92,11.1,11.1,0,0,1-4.13-1.32,9.63,9.63,0,0,1-2.32-1.78A2.86,2.86,0,0,1,279.48,312.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.4,374.19a3.71,3.71,0,0,1,.08-.74,7.94,7.94,0,0,1,.69-2,11.08,11.08,0,0,1,5.82-5.06,17.05,17.05,0,0,1,11.45-.41c2.06.61,4.42,1.37,6,3.38a3.59,3.59,0,0,1,.44,3.66,5.8,5.8,0,0,1-2.77,2.61,8.9,8.9,0,0,1-3.69.92,5.41,5.41,0,0,1-3.54-1.1,4.52,4.52,0,0,1-1.58-3.21,8.07,8.07,0,0,1,.53-3.37,15.14,15.14,0,0,1,8-8.12,15.8,15.8,0,0,1,7.66-1.32,10.89,10.89,0,0,1,2.8.59c0,.07-1-.26-2.82-.39A16,16,0,0,0,330.59,364a14,14,0,0,0-3.35,5,7.57,7.57,0,0,0-.49,3.17,4,4,0,0,0,1.42,2.85,4.86,4.86,0,0,0,3.2,1,8.26,8.26,0,0,0,3.46-.86,5.34,5.34,0,0,0,2.54-2.37,3.11,3.11,0,0,0-.38-3.15,7.21,7.21,0,0,0-2.61-2.06,18.7,18.7,0,0,0-3.07-1.15,16.82,16.82,0,0,0-11.18.29,11.06,11.06,0,0,0-5.78,4.81A10.69,10.69,0,0,0,313.4,374.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.48,388.24c0-.1,1.48-.22,3.73-1A18.65,18.65,0,0,0,303.15,374c.57-2.32.55-3.83.65-3.82a3.46,3.46,0,0,1,.05,1.05,15.17,15.17,0,0,1-.34,2.85,17.94,17.94,0,0,1-12.18,13.47,15.38,15.38,0,0,1-2.8.63A3.65,3.65,0,0,1,287.48,388.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.86,359.23a2,2,0,0,1,.47-.19c.32-.1.78-.24,1.39-.4a17.18,17.18,0,0,1,5.31-.54,11.16,11.16,0,0,1,3.6.89,8.35,8.35,0,0,1,3.36,2.64,6.9,6.9,0,0,1,1.31,4.54,5.58,5.58,0,0,1-.77,2.44,3.86,3.86,0,0,1-2,1.7,2.68,2.68,0,0,1-2.63-.52,3.51,3.51,0,0,1-.91-2.42,10.42,10.42,0,0,1,.92-4.63,10.15,10.15,0,0,1,11-5.91,8.16,8.16,0,0,1,1.41.35c.31.12.47.19.46.21s-.67-.21-1.9-.36a10.52,10.52,0,0,0-5.13.66,9.83,9.83,0,0,0-5.37,5.24,10.1,10.1,0,0,0-.85,4.41,3,3,0,0,0,.76,2.08,2.17,2.17,0,0,0,2.11.4,3.4,3.4,0,0,0,1.76-1.48,5.16,5.16,0,0,0,.7-2.21,6.49,6.49,0,0,0-1.19-4.22,7.83,7.83,0,0,0-3.15-2.52,10.81,10.81,0,0,0-3.46-.92,18.08,18.08,0,0,0-5.22.37C275.55,359.09,274.88,359.27,274.86,359.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M332.32,381.86c-4.16-2.35-8.23-4.16-12.58-6.13s-8.62-4.52-11.47-8.36c-5.37-7.24-4.76-17.69-10.25-24.83q.54,7.2,1.07,14.41c.33,4.4-.34,8.76,2.49,11.75,2.39,2.52,7.05,4.45,10.35,5.54,6.63,2.19,13.77,5.44,20.39,7.62"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M400,436.71s32.57,9,33.88,9.48c2,.69,1.63,7.88-1.42,7.76-1.45-.05-25,.88-28,.7s-12-3.73-12-3.73Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.53,449.14a28.68,28.68,0,0,1,1.44-3.5,29.19,29.19,0,0,1,2.3-3,7.2,7.2,0,0,0-3.74,6.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.13,447.6c.16,0,.49-1.51,1.36-3.21s1.89-2.89,1.78-3a8.15,8.15,0,0,0-3.14,6.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,446.75a21.72,21.72,0,0,1,.76-3.44,22.86,22.86,0,0,1,1.77-3.05,6.11,6.11,0,0,0-2.53,6.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.53,442.54a5.81,5.81,0,0,0,.35-2.42,12,12,0,0,0-.33-2.66,10.59,10.59,0,0,0-.49-1.51,1.72,1.72,0,0,0-.52-.8.88.88,0,0,0-1.12.06,1.41,1.41,0,0,0-.43.92,5,5,0,0,0,0,.86,6.72,6.72,0,0,0,.2,1.59,9.7,9.7,0,0,0,1,2.49,6.7,6.7,0,0,0,1.46,2c.08,0-.47-.81-1.12-2.14a10.64,10.64,0,0,1-.85-2.42,7.16,7.16,0,0,1-.16-1.49c0-.5,0-1.12.3-1.36a.32.32,0,0,1,.43,0,1.47,1.47,0,0,1,.36.57,12.9,12.9,0,0,1,.49,1.44,12.71,12.71,0,0,1,.43,2.54C407.59,441.61,407.44,442.53,407.53,442.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.49,442.21a4.57,4.57,0,0,0-2.1-.34,9.65,9.65,0,0,0-2.31.28,5.61,5.61,0,0,0-1.34.49,1.38,1.38,0,0,0-.73,1.49,1.65,1.65,0,0,0,1.17,1.17,3,3,0,0,0,1.46,0,5.46,5.46,0,0,0,2.12-1,5.66,5.66,0,0,0,1.51-1.49,16,16,0,0,0-1.73,1.17,5.74,5.74,0,0,1-2,.87,2.48,2.48,0,0,1-1.21,0,1.1,1.1,0,0,1-.79-.77.85.85,0,0,1,.48-.91,4.82,4.82,0,0,1,1.18-.46,10.48,10.48,0,0,1,2.2-.38C406.67,442.17,407.47,442.3,407.49,442.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.53,449.49a19.26,19.26,0,0,1,.65-2.94,17.78,17.78,0,0,1,1.59-2.55,4.69,4.69,0,0,0-2.24,5.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.81,451a5.84,5.84,0,0,0,1.26.6,30.21,30.21,0,0,0,3.62,1.12,52.1,52.1,0,0,0,12.44,1.18c4.88-.06,9.28-.28,12.47-.41l3.77-.2a8.24,8.24,0,0,0,1.38-.14,6.6,6.6,0,0,0-1.39-.07l-3.77,0-12.46.24a58.31,58.31,0,0,1-12.35-1C397.66,451.69,395.85,450.89,395.81,451Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.85,451.74c0,.07.93-.45,2.44-1.11a11.28,11.28,0,0,1,6.16-1,9.8,9.8,0,0,1,5.33,3.16,19.17,19.17,0,0,0,1.87,1.92,10,10,0,0,0-1.59-2.18,13,13,0,0,0-2.16-2,7.74,7.74,0,0,0-3.37-1.42,10.79,10.79,0,0,0-6.41,1.21A8.33,8.33,0,0,0,394.85,451.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.39,427.72s-30.82,20.18-31.92,21c-1.66,1.25.24,7.22,3.12,6.19,1.36-.49,27.22-7.69,30-8.77S376.86,439,376.86,439Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.24,443.68a7.21,7.21,0,0,0-5.54-5.05,28.34,28.34,0,0,1,3.11,2.16A30.26,30.26,0,0,1,356.24,443.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,441.18a8.17,8.17,0,0,0-4.87-5c-.08.14,1.27,1,2.6,2.32S358.86,441.26,359,441.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.78,439.4a5,5,0,0,0-1.34-3.39,5,5,0,0,0-3-2,23.73,23.73,0,0,1,2.61,2.37A21.92,21.92,0,0,1,361.78,439.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,435.57c.08,0-.34-.87-.69-2.31a12.56,12.56,0,0,1-.37-2.55,11.23,11.23,0,0,1,0-1.52,1.25,1.25,0,0,1,.17-.65.31.31,0,0,1,.42-.1c.35.14.53.74.7,1.22a7.73,7.73,0,0,1,.3,1.46,10.64,10.64,0,0,1-.08,2.57c-.21,1.46-.5,2.35-.42,2.38a6.48,6.48,0,0,0,.8-2.32,9.54,9.54,0,0,0,.2-2.67,7.54,7.54,0,0,0-.29-1.58,6.64,6.64,0,0,0-.3-.81,1.44,1.44,0,0,0-.7-.75.87.87,0,0,0-1.08.29,1.78,1.78,0,0,0-.25.92,11.22,11.22,0,0,0,.48,4.22A5.88,5.88,0,0,0,360,435.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.89,435.24c0,.08.76-.28,2-.59a11.14,11.14,0,0,1,2.21-.3,4.88,4.88,0,0,1,1.27.08.87.87,0,0,1,.74.72,1.12,1.12,0,0,1-.53,1,2.53,2.53,0,0,1-1.14.38,5.53,5.53,0,0,1-2.17-.22,14.58,14.58,0,0,0-2-.59,5.7,5.7,0,0,0,1.9,1,5.48,5.48,0,0,0,2.33.35,2.9,2.9,0,0,0,1.39-.44,1.62,1.62,0,0,0,.77-1.46,1.38,1.38,0,0,0-1.15-1.2,5.35,5.35,0,0,0-1.42-.06,9.83,9.83,0,0,0-2.29.43A4.63,4.63,0,0,0,359.89,435.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.51,453.8c0,.05.52-.31.76-1.19a4.62,4.62,0,0,0-.58-3.35,12.87,12.87,0,0,0-1-1.54,6,6,0,0,0-1.05-1.12,1.82,1.82,0,0,0-1-.41c-.26,0-.39.05-.39.08s.55.05,1.12.63a6.62,6.62,0,0,1,.89,1.12,17.63,17.63,0,0,1,1,1.5,4.76,4.76,0,0,1,.68,3A11.17,11.17,0,0,1,340.51,453.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.58,445.53a3.77,3.77,0,0,0-1.09-2.95,3.71,3.71,0,0,0-2.71-1.59,17.56,17.56,0,0,1,2.29,1.94A17.85,17.85,0,0,1,351.58,445.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.69,440.07a9.45,9.45,0,0,0-1.36.92,39.23,39.23,0,0,1-3.8,2.33,49.72,49.72,0,0,1-6,2.69c-2.34.87-5,1.69-7.72,2.49-5.55,1.6-10.57,3.06-14.19,4.15L336.31,454a9.44,9.44,0,0,0-1.55.56,10.44,10.44,0,0,0,1.61-.35L340.7,453c3.65-1,8.68-2.4,14.23-4,2.77-.81,5.4-1.65,7.74-2.55a45.83,45.83,0,0,0,6.05-2.82,30.49,30.49,0,0,0,3.74-2.5A9.79,9.79,0,0,0,373.69,440.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.83,440.48a8.88,8.88,0,0,0-2.61-.7,10.84,10.84,0,0,0-6.48.8A7.65,7.65,0,0,0,363,443a13,13,0,0,0-1.45,2.58,9.71,9.71,0,0,0-.85,2.56,20.2,20.2,0,0,0,1.2-2.4,9.79,9.79,0,0,1,4.12-4.64,11.31,11.31,0,0,1,6.18-.89C373.8,440.34,374.81,440.56,374.83,440.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.44,378.51s9.25,3.3,9.28,13.67c.08,19.85-40.12,41.74-40.12,41.74l-53.5-35.44-3.35-1.36S414,370,429.44,378.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.2,416.38a9.89,9.89,0,0,0,1.4-.94c.87-.64,2.12-1.58,3.65-2.77,3.07-2.36,7.23-5.72,11.72-9.57s8.43-7.46,11.23-10.13c1.4-1.33,2.52-2.43,3.29-3.2a9.43,9.43,0,0,0,1.14-1.23,9.77,9.77,0,0,0-1.29,1.08l-3.4,3.07c-2.87,2.59-6.85,6.16-11.33,10s-8.6,7.24-11.59,9.68l-3.55,2.9A10.58,10.58,0,0,0,372.2,416.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.34,385.93a13.29,13.29,0,0,0-9.74,2.87c.09.15,2-1.1,4.74-1.88S414.34,386.1,414.34,385.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.73,382.8a8.18,8.18,0,0,0-4.84,6c.16,0,.74-1.61,2.09-3.26S409.82,382.94,409.73,382.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.38,445.68c0-.06-.64-.19-1.38.42a4.92,4.92,0,0,0-1.54,3.1,6.09,6.09,0,0,0,.48,3.43c.38.81.8,1.19.85,1.15a9.65,9.65,0,0,0-.49-1.3,6.91,6.91,0,0,1-.3-3.2,5.36,5.36,0,0,1,1.26-2.9C431.83,445.79,432.39,445.77,432.38,445.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.13 346.06 398.08 394.36 316.05 395.7 314.53 391.26 343.28 390.22 357.1 347.37 417.13 346.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.82,367a3.66,3.66,0,0,1,3.95.43,3.17,3.17,0,0,1,.77,3.49,3.45,3.45,0,0,1-3,2.07,3.12,3.12,0,0,1-3.14-2.07,3.53,3.53,0,0,1,1.38-3.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.66,436.34S328.08,386.76,325,385.73s-10.58-5.93-18.05-3.87-14.19,8.77-17.54,18.57c-1.92,5.6-2.82,15.15-3.25,22.32a33.15,33.15,0,0,0,7.75,23.6,21.09,21.09,0,0,0,9.42,6.69c.79.25,1.61.46,2.45.64,14.29,3.1,29-3.32,37-15.54l1.76-2.68s49.45,18.16,50.22,17.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,422.69a4.22,4.22,0,0,0,.41.18l1.24.49,4.79,1.85,17.81,6.71c7.56,2.82,16.62,6.18,26.79,9.88s21.43,7.75,33.47,11.82l.21.08.11-.21,5.91-11.28,3-5.75.11-.22-.21-.13-57.65-36.6-17.32-10.92-4.7-2.94-1.23-.75c-.28-.17-.43-.24-.43-.24l.4.29,1.2.79,4.65,3L346,399.83l57.56,36.74-.1-.36c-.95,1.83-2,3.78-3,5.75l-5.9,11.28.33-.13c-12-4.06-23.3-8.1-33.48-11.77l-26.83-9.76L316.67,425l-4.82-1.76-1.26-.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,246.64c1.29-3.49,4.14-5,7.75-5.87a11.58,11.58,0,0,1,10.37,2.67c1.83,1.67,3.17,4,5.43,5,3.73,1.69,8.5-.78,12,1.29a5.28,5.28,0,0,1-3.4,9.78c2.43,1.14,2.88,4.8,1.21,6.9s-4.76,2.67-7.35,1.94a14.84,14.84,0,0,1-6.55-4.51c-1.82-2-3.42-4.15-5.4-6a11.49,11.49,0,0,0-7.12-3.38c-3.63-.14-7,2.31-8.89,5.4s-2.62,6.76-3.15,10.36-.93,7.26-2.32,10.62c-.16.4-.4.83-.81.92-.61.13-1.05-.54-1.29-1.11a53.27,53.27,0,0,1-4.26-20.3c-.05-4,.41-7.83,2.92-11s8.3-5.14,10.83-2.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.48,262.77l-5.56,40.38a12.13,12.13,0,0,0,11,13.73h0A12.14,12.14,0,0,0,328,306.43c.41-3,.76-5.57.83-5.88,0,0,10.41.45,12.55-9.62,1-4.87,2.35-15.07,3.44-24.31a19.18,19.18,0,0,0-15.3-21l-1-.19C317.87,243.91,310.67,252.11,309.48,262.77Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.82,300.41A24,24,0,0,1,316.41,294s1.66,7.88,11.91,9Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.47,272.8a1.46,1.46,0,0,1-1.68,1.17,1.39,1.39,0,0,1-1.22-1.59,1.46,1.46,0,0,1,1.68-1.18A1.4,1.4,0,0,1,340.47,272.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.61,271.14c-.22.16-1.15-.87-2.7-1.18s-2.85.25-3,0,.19-.4.76-.66a3.92,3.92,0,0,1,2.42-.25,3.83,3.83,0,0,1,2.1,1.17C341.62,270.7,341.71,271.08,341.61,271.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.15,270.28a1.46,1.46,0,0,1-1.68,1.18,1.42,1.42,0,0,1-1.23-1.6,1.49,1.49,0,0,1,1.68-1.18A1.41,1.41,0,0,1,325.15,270.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.3,268.39c-.22.15-1.15-.88-2.7-1.19s-2.85.25-3,0,.19-.4.76-.66a4,4,0,0,1,2.42-.25,4,4,0,0,1,2.11,1.17C326.31,268,326.4,268.32,326.3,268.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63,281a10.05,10.05,0,0,1,2.61.05c.41,0,.8,0,.92-.23a2,2,0,0,0,0-1.22c-.18-1-.37-2.12-.57-3.26-.77-4.62-1.24-8.38-1.06-8.41s1,3.69,1.73,8.31c.18,1.14.36,2.22.52,3.26a2.3,2.3,0,0,1-.11,1.6,1,1,0,0,1-.76.44,2.46,2.46,0,0,1-.69,0A10.62,10.62,0,0,1,329.63,281Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.85,281.18c.26,0-.08,1.72,1.12,3.2s3,1.66,3,1.9-.46.24-1.22.11a4.31,4.31,0,0,1-2.53-1.48,3.75,3.75,0,0,1-.83-2.67C324.47,281.52,324.74,281.14,324.85,281.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.91,262.38c-.23.4-1.74-.11-3.61-.26s-3.43.06-3.6-.37c-.07-.2.27-.54.94-.83a6.1,6.1,0,0,1,2.8-.4,6,6,0,0,1,2.7.88C327.75,261.8,328,262.2,327.91,262.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.93,266.54c-.34.3-1.33-.28-2.62-.56s-2.42-.23-2.59-.65c-.08-.2.16-.52.71-.76a3.71,3.71,0,0,1,2.25-.15,3.61,3.61,0,0,1,1.95,1.13C342,266,342.09,266.39,341.93,266.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.81,270.41c-.16-.11-6.53-3.44-7.69,3.51s6.06,6.68,6.1,6.48S308.81,270.41,308.81,270.41Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.54,277.41s-.13.07-.35.13a1.25,1.25,0,0,1-.91-.13,3,3,0,0,1-.94-2.92,4,4,0,0,1,.63-1.68A1.43,1.43,0,0,1,305,272a.63.63,0,0,1,.66.46c.06.2,0,.34,0,.35s.17-.09.16-.38a.79.79,0,0,0-.2-.48.88.88,0,0,0-.64-.29,1.72,1.72,0,0,0-1.44.86,4.22,4.22,0,0,0-.75,1.87c-.19,1.41.31,2.84,1.27,3.29a1.31,1.31,0,0,0,1.14,0C305.5,277.58,305.56,277.43,305.54,277.41Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.32,265a14.88,14.88,0,0,1-12.37-5.5c-2-2.58-3.33-5.95-6.22-7.51a8.39,8.39,0,0,0-6.45-.4,16.29,16.29,0,0,0-5.62,3.42c.92,5.52-1.53,11-3.92,16a2.79,2.79,0,0,1-1.13,1.43c-.94.47-2.06-.27-2.63-1.16a8.72,8.72,0,0,1-1-4.87,29.11,29.11,0,0,1,2.3-11.18,19.73,19.73,0,0,1,7.27-8.7,18.69,18.69,0,0,1,13.81-2.29,23,23,0,0,1,12.11,7.27,13.51,13.51,0,0,1,3.27,5.73",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.46,427.85a2,2,0,0,1,.18-.42l.56-1.21a30.9,30.9,0,0,0,1.67-4.84c1.1-4.3,1.48-10.87-.15-18.67a99.07,99.07,0,0,0-3.46-12.55c-1.47-4.45-3.17-9.17-4.56-14.28a55.38,55.38,0,0,1-2.25-16.42c.21-5.81,1.93-11.61,3.82-17.38s3.84-11.43,4.42-17.11a26,26,0,0,0-3.13-15.8c-2.51-4.62-5.65-8.56-8-12.65a44,44,0,0,1-4.82-12.15,45.35,45.35,0,0,1-.3-18.83,35.59,35.59,0,0,1,2-6.65,2.65,2.65,0,0,1-.11.45l-.4,1.27a44.95,44.95,0,0,0-.73,23.66,43.44,43.44,0,0,0,4.83,12c2.35,4,5.51,8,8.06,12.63A26.64,26.64,0,0,1,68.28,325c-.59,5.78-2.56,11.47-4.44,17.24s-3.59,11.5-3.8,17.21a55,55,0,0,0,2.19,16.26c1.37,5.08,3.06,9.8,4.5,14.27a98.38,98.38,0,0,1,3.41,12.62c1.59,7.86,1.13,14.5,0,18.81a27.46,27.46,0,0,1-1.78,4.83c-.26.5-.47.89-.62,1.19A2.62,2.62,0,0,1,67.46,427.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,300.55s-4.79-15.3,3.8-24.26a.53.53,0,0,1,.91.26C64.92,279.08,65.49,286.78,59.75,300.55Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.62,281.39a14.28,14.28,0,0,1-.33,2.82c-.31,2-.68,4.23-1.09,6.75s-.76,4.81-1.07,6.75a15,15,0,0,1-.51,2.8,12.27,12.27,0,0,1,.09-2.85c.16-1.75.47-4.15.9-6.79s.89-5,1.27-6.73A12.4,12.4,0,0,1,62.62,281.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.37,336.65S68.3,320.88,80.08,317a.53.53,0,0,1,.68.66C80,320.08,76.89,327.16,65.37,336.65Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.87,321.05a14.25,14.25,0,0,1-1.61,2.34c-1.18,1.58-2.58,3.42-4.12,5.46L67,334.32a15.43,15.43,0,0,1-1.76,2.23,12.25,12.25,0,0,1,1.41-2.48c1-1.47,2.35-3.45,4-5.58s3.14-4,4.27-5.36A12.36,12.36,0,0,1,76.87,321.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.19,376.2s-1.78-15.94,8.36-23.1a.53.53,0,0,1,.84.44C71.36,356.1,70.45,363.77,62.19,376.2Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.66,357.93a13.46,13.46,0,0,1-.86,2.71c-.68,1.85-1.47,4-2.36,6.42l-2.33,6.42a14.8,14.8,0,0,1-1,2.65,12.8,12.8,0,0,1,.63-2.78c.49-1.69,1.25-4,2.18-6.5s1.84-4.75,2.53-6.36A12.51,12.51,0,0,1,68.66,357.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.06,416s-1.21-16,9.18-22.78a.53.53,0,0,1,.83.46C80.94,396.23,79.76,403.86,71.06,416Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.18,398a13.85,13.85,0,0,1-1,2.68c-.75,1.82-1.62,4-2.59,6.32l-2.57,6.34A15.25,15.25,0,0,1,71,415.9a12.11,12.11,0,0,1,.73-2.75c.54-1.67,1.39-3.94,2.41-6.41s2-4.69,2.75-6.27A12.68,12.68,0,0,1,78.18,398Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.87,287.11s-14.21-7.42-14.49-19.83a.53.53,0,0,1,.83-.46C41.32,268.28,47.17,273.31,52.87,287.11Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.33,271.54a13.9,13.9,0,0,1,1.77,2.22l4,5.54,4,5.53a15.67,15.67,0,0,1,1.62,2.33,11.33,11.33,0,0,1-2-2.07c-1.13-1.34-2.62-3.26-4.18-5.43s-2.92-4.18-3.87-5.66A12.28,12.28,0,0,1,41.33,271.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.13,320s-14.63-6.54-15.67-18.91a.53.53,0,0,1,.8-.5C55.46,301.88,61.61,306.55,68.13,320Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.67,305.14a14.22,14.22,0,0,1,1.9,2.11l4.34,5.29,4.35,5.27A14.5,14.5,0,0,1,68,320a12.88,12.88,0,0,1-2.07-2c-1.21-1.28-2.81-3.1-4.5-5.17s-3.17-4-4.2-5.41A12.22,12.22,0,0,1,55.67,305.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.71,356.64s-10.05-12.5-5.33-24a.53.53,0,0,1,.94-.09C56.67,334.76,60,341.71,59.71,356.64Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.37,337.75a13.86,13.86,0,0,1,.73,2.74c.42,1.93.91,4.19,1.46,6.69s1,4.75,1.47,6.67a15.67,15.67,0,0,1,.55,2.79,11.45,11.45,0,0,1-1-2.68c-.5-1.69-1.09-4-1.65-6.66s-1-5-1.28-6.72A13,13,0,0,1,55.37,337.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.67,399.78S55.14,393,54.32,380.6a.53.53,0,0,1,.8-.49C57.3,381.48,63.37,386.25,69.67,399.78Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.45,384.73a14,14,0,0,1,1.87,2.14c1.22,1.55,2.66,3.36,4.25,5.36l4.26,5.35a15.68,15.68,0,0,1,1.72,2.26,11.87,11.87,0,0,1-2-2c-1.18-1.29-2.75-3.14-4.4-5.24S60,388.56,59,387.13A13.34,13.34,0,0,1,57.45,384.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6,336.73a1.55,1.55,0,0,1,0,.36c0,.28,0,.61,0,1,0,1-.1,2.27-.17,3.89-.19,3.42-.45,8.18-.76,13.89h0v0c-1,5.8-4,12.23-8,18.47-2.91,4.6-6,8.79-8.59,12.68a89.56,89.56,0,0,0-6.45,10.65,44.71,44.71,0,0,0-3,7.82c-.26.95-.45,1.7-.56,2.21a4,4,0,0,1-.21.77,3.93,3.93,0,0,1,.09-.79c.07-.52.23-1.28.45-2.25a41.72,41.72,0,0,1,2.86-8,85.88,85.88,0,0,1,6.37-10.77c2.61-3.92,5.65-8.11,8.55-12.68,4-6.22,6.88-12.55,8-18.26v0c.4-5.69.73-10.45,1-13.87.13-1.62.24-2.92.31-3.88,0-.4.08-.74.11-1A1.12,1.12,0,0,1,98.6,336.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,373.2s6.15-14.81-1.59-24.51a.53.53,0,0,0-.93.18C86.75,351.35,85.48,359,90,373.2Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.83,353.86a13,13,0,0,1,.49,2.8c.22,1.74.46,4.15.65,6.82s.28,5.09.28,6.84a11.45,11.45,0,0,1-.17,2.84,14.71,14.71,0,0,1-.25-2.82c-.13-2-.29-4.27-.46-6.82s-.34-4.86-.47-6.82A14.44,14.44,0,0,1,88.83,353.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90,373.2s6.15-14.81-1.59-24.51a.53.53,0,0,0-.93.18C86.75,351.35,85.48,359,90,373.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M70.9,408.88s4.93-15.25-3.57-24.29a.53.53,0,0,0-.91.25C65.93,387.36,65.29,395.05,70.9,408.88Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.21,389.69a12.66,12.66,0,0,1,.71,2.76c.36,1.71.8,4.09,1.21,6.74s.69,5.05.83,6.8a11.72,11.72,0,0,1,.06,2.85,15.84,15.84,0,0,1-.48-2.8c-.29-2-.63-4.23-1-6.76s-.73-4.81-1-6.76A14.48,14.48,0,0,1,68.21,389.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9,408.88s4.93-15.25-3.57-24.29a.53.53,0,0,0-.91.25C65.93,387.36,65.29,395.05,70.9,408.88Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M97.78,355.11s13.14-9.2,11.81-21.54a.53.53,0,0,0-.88-.35C106.81,335,101.65,340.69,97.78,355.11Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.78,355.11s13.14-9.2,11.81-21.54a.53.53,0,0,0-.88-.35C106.81,335,101.65,340.69,97.78,355.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M107.22,338.18a12.84,12.84,0,0,1-1.09,2.62c-.75,1.59-1.84,3.75-3.11,6.11s-2.49,4.45-3.44,5.93a10.93,10.93,0,0,1-1.67,2.3,15.92,15.92,0,0,1,1.31-2.52l3.27-6,3.26-6A13.83,13.83,0,0,1,107.22,338.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.19,393.76S92,391.29,96.28,379.63a.53.53,0,0,0-.64-.7C93.17,379.63,86,382.52,76.19,393.76Z",
    style: {
      fill: "#BCCAF6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.19,393.76S92,391.29,96.28,379.63a.53.53,0,0,0-.64-.7C93.17,379.63,86,382.52,76.19,393.76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M92.12,382.72A13.4,13.4,0,0,1,90,384.59c-1.37,1.1-3.3,2.56-5.48,4.11s-4.2,2.9-5.69,3.82a11.83,11.83,0,0,1-2.52,1.33,15.63,15.63,0,0,1,2.28-1.69l5.59-3.94,5.57-4A13.52,13.52,0,0,1,92.12,382.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.08 422.92 56.46 454.02 85.26 454.02 81.52 422.92 61.08 422.92",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.68,432.55c0,.17-5.2.3-11.62.3s-11.61-.13-11.61-.3a114.58,114.58,0,0,1,11.61-.3A114.71,114.71,0,0,1,82.68,432.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.25,435c0,.16-5.37.3-12,.3s-12-.14-12-.3,5.37-.3,12-.3S83.25,434.86,83.25,435Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorktimePana);
export default __webpack_public_path__ + "static/media/Work time-pana.a2020777327d61a0a6a0048744c1cde9.svg";
export { ForwardRef as ReactComponent };